/** Typed getElementById that throws when the markup and code drift apart. */
export function byId<T extends HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Missing element #${id}`);
  return el as T;
}

export function formatTime(sec: number): string {
  if (!Number.isFinite(sec)) return '0.000s';
  return `${sec.toFixed(3)}s`;
}
